export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setCompradores(state, payload) {
    state.selects.compradores = payload;
  },
  setAno(state, payload) {
    state.ano = payload;
  },
  setOrcamentos(state, payload) {
    if (payload) {
      state.orcamento.comprador = state.selects.compradores.find(
        c => c.value == payload.comprador_id
      );
      state.orcamento.ano = payload.ano;
      state.orcamento.itens = payload.itens;
    } else {
      state.orcamento = {
        comprador: "",
        ano: "",
        itens: []
      };
    }
  },
  setOrcamento(state, payload) {
    state.orcamento.comprador = payload.comprador;
    state.orcamento.ano = payload.ano;
    if (state.orcamento.itens) {
      state.orcamento.itens.push(payload.itens);
    } else {
      state.orcamento.itens = [payload.itens];
    }
  },
  setTotalPrevistoCompra(state, payload) {
    state.orcamento.itens.find(
      oi => oi.mes == payload.mes
    ).total_previsto_compra = payload.total_previsto_compra;
  },
  setDetalhes(state, payload) {
    state.itens.find(i => i.comprador_id == payload.comprador_id).detalhes =
      payload.detalhes;
  },
  excluir(state, payload) {
    state.orcamento.itens.splice(state.orcamento.itens.indexOf(payload), 1);
  },
  sortDetalhes(state, payload) {
    var detalhes = {};
    if (payload.comprador_id) {
      detalhes = state.itens.find(i => i.comprador_id == payload.comprador_id)
        .detalhes;
    } else {
      detalhes = state.itens;
    }
    detalhes.sort((a, b) => {
      let compare = 0;
      if (a[payload.key] > b[payload.key]) {
        compare = payload.order;
      } else if (b[payload.key] > a[payload.key]) {
        compare = -payload.order;
      }
      return compare;
    });
    if (payload.comprador_id) {
      state.itens.find(
        i => i.comprador_id == payload.comprador_id
      ).detalhes = detalhes;
    }
  }
};
